import { render, staticRenderFns } from "./SystemInformList.vue?vue&type=template&id=79d93268&scoped=true"
import script from "./SystemInformList.vue?vue&type=script&lang=js"
export * from "./SystemInformList.vue?vue&type=script&lang=js"
import style0 from "./SystemInformList.vue?vue&type=style&index=0&id=79d93268&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d93268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d93268')) {
      api.createRecord('79d93268', component.options)
    } else {
      api.reload('79d93268', component.options)
    }
    module.hot.accept("./SystemInformList.vue?vue&type=template&id=79d93268&scoped=true", function () {
      api.rerender('79d93268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/systemInform/SystemInformList.vue"
export default component.exports